/* ============================================================
   CiemnaSzyba — podgląd zakresu (SVG)
   Port window.setCoverage ze strony produktu (linie 77–111).

   RÓŻNICE WOBEC ŹRÓDŁA — obie zamierzone:
   1. Wyszukiwanie po [data-szyba] w obrębie PRZEKAZANEGO kontenera,
      nie po document.getElementById. Źródło używało globalnych id,
      przez co: (a) ścieżka nadwozia w SVG miała id="nadwozie" —
      identycznie jak select typu nadwozia, (b) dwa wystąpienia
      widgetu (np. / i /products/…, albo edytor motywu) łamały
      unikalność id.
   2. Klucz 'przednie-bagaznik' USUNIĘTY — martwy, żaden zakres
      na niego nie wskazywał, a wariant „Przednie boczne + bagażnik"
      jest wycofywany.
   3. NAZWY odwzorowują 1:1 etykiety kart zakresu z buy boxa. Źródło miało
      własne nazwy, rozjeżdżone z kartami w trzech miejscach: „Tylne komplet”,
      „Wszystkie boczne + tylna”, „Tylne boczne + małe okna”.

   Szyba czołowa i nadwozie NIE należą do zbioru przełączanego.
   ============================================================ */
(function () {
  "use strict";

  var WSZYSTKIE = ["przod-L", "przod-P", "tyl-L", "tyl-P", "male-L", "male-P", "tylna"];

  var MAPOWANIE = {
    "tylna-szyba":            ["tylna"],
    "tylna-szyba-male":       ["tylna", "male-L", "male-P"],
    "tylne-boczne-male":      ["tyl-L", "tyl-P", "male-L", "male-P"],
    "przednie-boczne":        ["przod-L", "przod-P"],
    "tylne-komplet":          ["tylna", "tyl-L", "tyl-P", "male-L", "male-P"],
    "wszystkie-boczne":       ["przod-L", "przod-P", "tyl-L", "tyl-P", "male-L", "male-P"],
    "wszystkie-boczne-tylna": ["przod-L", "przod-P", "tyl-L", "tyl-P", "male-L", "male-P", "tylna"]
  };

  var NAZWY = {
    "tylna-szyba":            "Tylna szyba",
    "tylna-szyba-male":       "Tylna szyba + małe okienka",
    "tylne-boczne-male":      "Tylne boczne",
    "przednie-boczne":        "Przednie boczne",
    "tylne-komplet":          "Komplet tylny",
    "wszystkie-boczne":       "Wszystkie boczne",
    "wszystkie-boczne-tylna": "Komplet pełny"
  };

  function set(root, klucz) {
    if (!root) return;
    var widget = root.matches("[data-cs-coverage]") ? root : root.querySelector("[data-cs-coverage]");
    if (!widget) return;

    var aktywne = MAPOWANIE[klucz] || [];

    WSZYSTKIE.forEach(function (id) {
      var el = widget.querySelector('[data-szyba="' + id + '"]');
      if (el) el.classList.toggle("aktywna", aktywne.indexOf(id) !== -1);
    });

    var name = widget.querySelector("[data-cs-coverage-name]");
    /* ⚠ Etykieta z i18n; `NAZWY` pełni odtąd rolę ZAPASU (wartości polskie).
       Tłumaczy się `configurator.coverage.*`, nie tę mapę. Klucze są kluczami
       `MAPOWANIE` i muszą zostać dosłownie. */
    if (name) name.textContent = CS.t("coverage." + klucz, NAZWY[klucz] || "—");
  }

  window.CSCoverage = { set: set, MAPOWANIE: MAPOWANIE, NAZWY: NAZWY };
})();
